import { render, staticRenderFns } from "./DispensacionNuevaEps.vue?vue&type=template&id=741411a3&scoped=true"
import script from "./DispensacionNuevaEps.vue?vue&type=script&lang=js"
export * from "./DispensacionNuevaEps.vue?vue&type=script&lang=js"
import style0 from "./DispensacionNuevaEps.vue?vue&type=style&index=0&id=741411a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741411a3",
  null
  
)

export default component.exports